export const PROJECT_CREATE_REQUEST = 'PROJECT_CREATE_REQUEST'
export const PROJECT_CREATE_SUCCESS = 'PROJECT_CREATE_SUCCESS'
export const PROJECT_CREATE_FAIL = 'PROJECT_CREATE_FAIL'
export const PROJECT_CREATE_RESET = 'PROJECT_CREATE_RESET'

export const PROJECT_DETAILS_REQUEST = 'PROJECT_DETAILS_REQUEST'
export const PROJECT_DETAILS_SUCCESS = 'PROJECT_DETAILS_SUCCESS'
export const PROJECT_DETAILS_FAIL = 'PROJECT_DETAILS_FAIL'
export const PROJECT_DETAILS_RESET = 'PROJECT_DETAILS_RESET'

export const PROJECT_REQUESTS_DETAILS_REQUEST =
  'PROJECT_REQUESTS_DETAILS_REQUEST'
export const PROJECT_REQUESTS_DETAILS_SUCCESS =
  'PROJECT_REQUESTS_DETAILS_SUCCESS'
export const PROJECT_REQUESTS_DETAILS_FAIL = 'PROJECT_REQUESTS_DETAILS_FAIL'
export const PROJECT_REQUESTS_DETAILS_RESET = 'PROJECT_REQUESTS_DETAILS_RESET'

export const PROJECT_UPDATE_REQUEST = 'PROJECT_UPDATE_REQUEST'
export const PROJECT_UPDATE_SUCCESS = 'PROJECT_UPDATE_SUCCESS'
export const PROJECT_UPDATE_NO_TOAST = 'PROJECT_UPDATE_NO_TOAST'
export const PROJECT_UPDATE_FAIL = 'PROJECT_UPDATE_FAIL'
export const PROJECT_UPDATE_RESET = 'PROJECT_UPDATE_RESET'

export const PROJECT_SUBMIT_QUOTE_REQUEST = 'PROJECT_SUBMIT_QUOTE_REQUEST'
export const PROJECT_SUBMIT_QUOTE_SUCCESS = 'PROJECT_SUBMIT_QUOTE_SUCCESS'
export const PROJECT_SUBMIT_QUOTE_FAIL = 'PROJECT_SUBMIT_QUOTE_FAIL'
export const PROJECT_SUBMIT_QUOTE_RESET = 'PROJECT_SUBMIT_QUOTE_RESET'

export const PROJECT_UPDATE_QUOTE_REQUEST = 'PROJECT_UPDATE_QUOTE_REQUEST'
export const PROJECT_UPDATE_QUOTE_SUCCESS = 'PROJECT_UPDATE_QUOTE_SUCCESS'
export const PROJECT_UPDATE_QUOTE_FAIL = 'PROJECT_UPDATE_QUOTE_FAIL'
export const PROJECT_UPDATE_QUOTE_RESET = 'PROJECT_UPDATE_QUOTE_RESET'

export const PROJECT_ADD_PO_DOCS_REQUEST = 'PROJECT_ADD_PO_DOCS_REQUEST'
export const PROJECT_ADD_PO_DOCS_SUCCESS = 'PROJECT_ADD_PO_DOCS_SUCCESS'
export const PROJECT_ADD_PO_DOCS_FAIL = 'PROJECT_ADD_PO_DOCS_FAIL'
export const PROJECT_ADD_PO_DOCS_RESET = 'PROJECT_ADD_PO_DOCS_RESET'

export const PROJECT_AE_ADD_PO_DOCS_REQUEST = 'PROJECT_AE_ADD_PO_DOCS_REQUEST'
export const PROJECT_AE_ADD_PO_DOCS_SUCCESS = 'PROJECT_AE_ADD_PO_DOCS_SUCCESS'
export const PROJECT_AE_ADD_PO_DOCS_FAIL = 'PROJECT_AE_ADD_PO_DOCS_FAIL'
export const PROJECT_AE_ADD_PO_DOCS_RESET = 'PROJECT_AE_ADD_PO_DOCS_RESET'

export const PROJECT_ADD_CONTRIB_REQUEST = 'PROJECT_ADD_CONTRIB_REQUEST'
export const PROJECT_ADD_CONTRIB_SUCCESS = 'PROJECT_ADD_CONTRIB_SUCCESS'
export const PROJECT_ADD_CONTRIB_FAIL = 'PROJECT_ADD_CONTRIB_FAIL'
export const PROJECT_ADD_CONTRIB_RESET = 'PROJECT_ADD_CONTRIB_RESET'

export const PROJECT_REMOVE_CONTRIB_REQUEST = 'PROJECT_REMOVE_CONTRIB_REQUEST'
export const PROJECT_REMOVE_CONTRIB_SUCCESS = 'PROJECT_REMOVE_CONTRIB_SUCCESS'
export const PROJECT_REMOVE_CONTRIB_FAIL = 'PROJECT_REMOVE_CONTRIB_FAIL'
export const PROJECT_REMOVE_CONTRIB_RESET = 'PROJECT_REMOVE_CONTRIB_RESET'

export const PROJECT_DELETE_REQUEST = 'PROJECT_DELETE_REQUEST'
export const PROJECT_DELETE_SUCCESS = 'PROJECT_DELETE_SUCCESS'
export const PROJECT_DELETE_FAIL = 'PROJECT_DELETE_FAIL'
export const PROJECT_DELETE_RESET = 'PROJECT_DELETE_RESET'

export const PROJECT_LIST_REQUEST = 'PROJECT_LIST_REQUEST'
export const PROJECT_LIST_SUCCESS = 'PROJECT_LIST_SUCCESS'
export const PROJECT_LIST_FAIL = 'PROJECT_LIST_FAIL'
export const PROJECT_LIST_RESET = 'PROJECT_LIST_RESET'

export const PROJECT_ALL_LIST_REQUEST = 'PROJECT_ALL_LIST_REQUEST'
export const PROJECT_ALL_LIST_SUCCESS = 'PROJECT_ALL_LIST_SUCCESS'
export const PROJECT_ALL_LIST_FAIL = 'PROJECT_ALL_LIST_FAIL'
export const PROJECT_ALL_LIST_RESET = 'PROJECT_ALL_LIST_RESET'

export const PROJECT_FILES_REQUEST = 'PROJECT_FILES_REQUEST'
export const PROJECT_FILES_SUCCESS = 'PROJECT_FILES_SUCCESS'
export const PROJECT_FILES_FAIL = 'PROJECT_FILES_FAIL'
export const PROJECT_FILES_RESET = 'PROJECT_FILES_RESET'

export const PROJECT_FILE_DELETE_REQUEST = 'PROJECT_FILE_DELETE_REQUEST'
export const PROJECT_FILE_DELETE_SUCCESS = 'PROJECT_FILE_DELETE_SUCCESS'
export const PROJECT_FILE_DELETE_FAIL = 'PROJECT_FILE_DELETE_FAIL'
export const PROJECT_FILE_DELETE_RESET = 'PROJECT_FILE_DELETE_RESET'

export const PROJECT_MARK_AS_PAID_REQUEST = 'PROJECT_MARK_AS_PAID_REQUEST'
export const PROJECT_MARK_AS_PAID_SUCCESS = 'PROJECT_MARK_AS_PAID_SUCCESS'
export const PROJECT_MARK_AS_PAID_FAIL = 'PROJECT_MARK_AS_PAID_FAIL'
export const PROJECT_MARK_AS_PAID_RESET = 'PROJECT_MARK_AS_PAID_RESET'

export const PROJECT_DOCUMENT_SIGNED_REQUEST = 'PROJECT_DOCUMENT_SIGNED_REQUEST'
export const PROJECT_DOCUMENT_SIGNED_SUCCESS = 'PROJECT_DOCUMENT_SIGNED_SUCCESS'
export const PROJECT_DOCUMENT_SIGNED_FAIL = 'PROJECT_DOCUMENT_SIGNED_FAIL'
export const PROJECT_DOCUMENT_SIGNED_RESET = 'PROJECT_DOCUMENT_SIGNED_RESET'

export const PROJECT_DELIVERABLES_REQUEST = 'PROJECT_DELIVERABLES_REQUEST'
export const PROJECT_DELIVERABLES_SUCCESS = 'PROJECT_DELIVERABLES_SUCCESS'
export const PROJECT_DELIVERABLES_FAIL = 'PROJECT_DELIVERABLES_FAIL'
export const PROJECT_DELIVERABLES_RESET = 'PROJECT_DELIVERABLES_RESET'

export const PROJECT_REMOVE_DELIVERABLE_REQUEST =
  'PROJECT_REMOVE_DELIVERABLE_REQUEST'
export const PROJECT_REMOVE_DELIVERABLE_SUCCESS =
  'PROJECT_REMOVE_DELIVERABLE_SUCCESS'
export const PROJECT_REMOVE_DELIVERABLE_FAIL = 'PROJECT_REMOVE_DELIVERABLE_FAIL'
export const PROJECT_REMOVE_DELIVERABLE_RESET =
  'PROJECT_REMOVE_DELIVERABLE_RESET'

export const PROJECT_ARCHIVE_REQUEST = 'PROJECT_ARCHIVE_REQUEST'
export const PROJECT_ARCHIVE_SUCCESS = 'PROJECT_ARCHIVE_SUCCESS'
export const PROJECT_ARCHIVE_FAIL = 'PROJECT_ARCHIVE_FAIL'
export const PROJECT_ARCHIVE_RESET = 'PROJECT_ARCHIVE_RESET'

export const PROJECT_CURRENT_STEP = 'PROJECT_CURRENT_STEP'
export const PROJECT_CURRENT_STEP_RESET = 'PROJECT_CURRENT_STEP_RESET'

export const PROJECT_EXIT_REQUEST = 'PROJECT_EXIT_REQUEST'
export const PROJECT_EXIT_RESET = 'PROJECT_EXIT_RESET'
